import {createSlice} from "@reduxjs/toolkit"
import { RootState } from "../LiquiBotSiteStore"
import PinkCommandIcon from "../../Icons/pinkCommandIcon.png";
import PingMessageIcon from "../../Icons/pinkMessagesIcon.png";
import PinkActivityIcon from "../../Icons/pinkActivityIcon.png";
import { DESCRIPTIONS } from "./commandDescriptions";

export type CommandUsageCount = {
    [key:string] : number;
}

export type StaticDataResponse = {
    [key:string] : number | CommandUsageCount,
}

export type LandingDataType = {
        name: string;
        number: number;
        icon: string;
}[]

export type CommandsList = {
    commands: string[];
    descriptions: string[];
}


interface DataState {
    staticData: StaticDataResponse | undefined;
    landingData: LandingDataType | undefined;
    commandsList: CommandsList | undefined;
    loading: boolean;
}

const initialState: DataState = {
    staticData: undefined,
    landingData: undefined,
    commandsList: undefined,
    loading: true
}

const landingEntries = ['current number of users', 'number of commands', 'total commands used', 'total messages']
const landingNames = ['users', 'commands', 'commands used', 'messages']
const icons = [PingMessageIcon,PinkCommandIcon,PinkActivityIcon,'']
const MassageLandingData = (data:StaticDataResponse) => {
    const massagedData: LandingDataType = [];
    Object.keys(data).forEach(entry => {
        if(landingEntries.includes(entry))
        massagedData.push({
            name: landingNames[landingEntries.indexOf(entry)],
            number: data[entry] as number,
            icon: icons[landingEntries.indexOf(entry)]
        })
    })
    return massagedData.sort((a,b) => b.number-a.number);
}
const MassageCommandsList = (data:StaticDataResponse) => {
    const commandList : CommandsList = {commands: [], descriptions: []};
    Object.keys(data).forEach(entry => {
        if(entry === 'commands usage count'){

            commandList.commands.push(...Object.keys(data[entry]).filter(command => command !== 'unload' && command!=='load'))
        }
    });
    commandList.descriptions = [...DESCRIPTIONS]
    return commandList;
}

export const DataSlice = createSlice({
    name: 'data',
    initialState,
    reducers : {
        setStaticData: (state,action) => {
            state.staticData = action.payload
        },
        setLandingData: (state,action) => {
            const landingDataMassaged : LandingDataType = MassageLandingData(action.payload);
            const commandsListMassaged = MassageCommandsList(action.payload);
            state.landingData = landingDataMassaged;
            state.commandsList = commandsListMassaged;
        },
        setLoading: (state,action) => {
            state.loading = action.payload
        }
    }
})

export const {setStaticData, setLandingData, setLoading} = DataSlice.actions;
export const selectStaticData = (state:RootState) => state.data.staticData;
export const selectLandingData = (state:RootState) => state.data.landingData;
export const selectCommandsList = (state:RootState) => state.data.commandsList;
export const selectLoadingData = (state:RootState) => state.data.loading;